import { submitFormJson, getContentByUrl } from 'widgets/toolbox/ajax';
import { timeout, showErrorLayout } from 'widgets/toolbox/util';
import { showPageLoader, hidePageLoader } from 'widgets/toolbox/progress';
import { windowScrollTo, elementInViewport, getScrollTop, getHeaderHeight } from 'widgets/toolbox/scroll';
import Widget from '../Widget';

/**
 * @description Implementation
 * @param {typeof import('widgets/Widget').default} baseInput Base widget for extending
 */
export default class ProductDetail extends Widget {
    prefs() {
        return {
            textNetworkError: 'Network Error',
            elNotifyMsg: 'addToCartMsg',
            classesAdded: 'm-added',
            classesStickyBackToTop: 'sticky-actions--back-to-top',
            classesStickyNoHeader: 'sticky-actions--no-header',
            msgTime: 6000,
            ...super.prefs()
        };
    }
    init() {
        this.readyToOrder = this.prefs().readyToOrder;
        this.isquickview = this.prefs().isquickview;

        const page = document.documentElement.querySelector('#page');
        const isPDPVariation1 = page?.classList.contains('pdp-layout-test-1');
        const isPDPVariation2 = page?.classList.contains('pdp-layout-test-2');
        let variant1Activated = false;
        let variant2Activated = false;

        if (isPDPVariation1) {
            variant1Activated = true;
        }

        if (isPDPVariation2) {
            this.setHeightOnScroll();
            variant2Activated = true;
        }

        const activatePDPVariant = window.activatePDPVariant;
        window.activatePDPVariant = (variant) => {
            if (activatePDPVariant) {
                activatePDPVariant(variant);
            }
            variant = +variant;
            if (variant === 1 && !variant1Activated) {
                page?.classList.remove('pdp-layout-test-2');
                page?.classList.add('pdp-layout-test-1');
            } else if (variant === 2 && !variant2Activated) {
                page?.classList.remove('pdp-layout-test-1');
                page?.classList.add('pdp-layout-test-2');
            }
        }

        if (this.has('stickyActions')) {
            this.initStickyActions();
        }

        window.document.onreadystatechange = function () {
            setTimeout(() => {
                window.redirected = false;
                window.addEventListener('popstate', event => {
                    event.preventDefault();
                    if (!window.redirected) {
                        window.redirected = true;
                        if (window.history.state) {
                            window.history.go(-(window.history.state.stateCount));
                        } else {
                            window.history.go(-1);
                        }
                    }
                });
            }, 500);
        };
        window.addEventListener('message', this.trackSubmissionResponse.bind(this));
    }

    trackSubmissionResponse(event) {
        if (event.origin.indexOf('bazaarvoice') > -1) {
            var data = event.data;
            if (typeof data === 'string' && data.indexOf('returnSubmissionResponse') > -1) {
                var pos = data.indexOf('{');
                if (pos > -1) {
                    var returnSubmissionResponse = JSON.parse(data.substring(pos));
                    if (returnSubmissionResponse.params.length > 0 && !returnSubmissionResponse.params[0].HasErrors) {
                        this.eventBus().emit('review.confirmed');
                    }
                }
            }
        }
    }

    initStickyActions() {
        this.has('actions', actions => {
            let positionBackToTop = 0;
            let positionLast = document.documentElement.scrollTop;
            let stateBackToTop = false;
            let stateNoHeader = false;
            let headerHeight = getHeaderHeight();

            const checkState = (stateVar, stateClass, stateCondition) => {
                if (stateCondition) {
                    if (!stateVar) {
                        this.ref('html').addClass(stateClass);
                        return true;
                    }
                } else if (stateVar) {
                    this.ref('html').removeClass(stateClass);
                    return false;
                }

                return stateVar;
            };

            const updateState = () => {
                const scrollTop = getScrollTop();
                stateNoHeader = checkState(
                    stateNoHeader,
                    this.prefs().classesStickyNoHeader,
                    scrollTop > Math.max(positionLast, 30)
                );
                stateBackToTop = checkState(
                    stateBackToTop,
                    this.prefs().classesStickyBackToTop,
                    scrollTop > positionBackToTop + (stateNoHeader ? headerHeight : 0)
                );

                positionLast = getScrollTop();
            };

            const calculatePositions = () => {
                this.ref('html').removeClass(this.prefs().classesStickyBackToTop);
                this.ref('html').removeClass(this.prefs().classesStickyNoHeader);
                stateBackToTop = false;
                stateNoHeader = false;
                headerHeight = getHeaderHeight();
                positionBackToTop = actions.offset().top + actions.prop('clientHeight') - headerHeight;
                updateState();
            };

            calculatePositions();

            let windowInnerWidth = window.innerWidth;
            window.addEventListener('resize', () => {
                if (windowInnerWidth !== window.innerWidth) {
                    windowInnerWidth = window.innerWidth;
                    calculatePositions.call(this);
                }
            });
            window.addEventListener('scroll', updateState.bind(this));
        });
    }
    /**
     * handle all 'Add to cart' buttons
     *
     * @param {Function} cb
     */
    addToCartButtons(cb) {
        ['addToCart', 'addToCart2'].forEach(buttonID => this.has(buttonID, button => cb(button)));
    }
    /**
     * handle response from server after product added
     *
     * @param {any} response
     */
    postAddProduct(response) {
        if (response.error) {
            this.showNotifyMsg(response.message, true);
        } else {
            if (response.cart) {
                this.eventBus().emit('product.detail.added.to.cart', response.cart, this);
            }
            this.showNotifyMsg(response.message);
            this.addToCartButtons((button) => {
                button.disable();
                button.ref('self').addClass(this.prefs().classesAdded);
            });
            timeout(() => {
                this.addToCartButtons((button) => {
                    button.enable();
                    button.ref('self').removeClass(this.prefs().classesAdded);
                });
            }, this.data('isSet') ? this.config.sitePreferences.PRODUCT_SET_TIME_TO_SHOW_ADDED : 2000);
            this.emit('addedtocart');
            this.eventBus().emit('emarsys.update');
        }
    }
    addToCart(button) {
        const errorSelectionAddToCart = document.getElementById('errorSelectionAddToCart');
        let selections = null;

        if (errorSelectionAddToCart) {
            const stringifySelection =
            errorSelectionAddToCart.getAttribute('data-text');
            if (stringifySelection) {
                selections = stringifySelection;
            }
        }

        const variationsElement = document.querySelector('.b-product__variations');
        let everythingSelected = false;

        if (variationsElement) {
            const sizeContainer = variationsElement.querySelector('[data-id="attr-size"]');
            const lengthContainer = variationsElement.querySelector('[data-id="attr-length"]');

            if (
                sizeContainer &&
                sizeContainer.querySelector('.selectable.selected')
            ) {
                everythingSelected = true;
            } else if (
                sizeContainer &&
                sizeContainer.querySelector('.selectable.selected') &&
                lengthContainer &&
                lengthContainer.querySelector('.selectable.selected')
            ) {
                everythingSelected = true;
            }
        }

        if (!everythingSelected && selections && errorSelectionAddToCart) {
            errorSelectionAddToCart.innerText = selections;
            errorSelectionAddToCart.classList.remove('b-product-variation__hidden');
            return;
        }

        if (!this.readyToOrder) {
            this.has('variations', variations => {
                if (!elementInViewport(variations.get())) {
                    windowScrollTo(variations.offset().top);
                }
            });
            return;
        }

        const addToCartUrl = button.prefs().addToCartUrl;
        const addToCartParams = {
            pid: this.currentProductID || button.prefs().pid,
            quantity: this.selectedQuantity || 1
        };
        const childPids = [];

        this.addToCartButtons((button) => {
            button.ref('self').addClass(this.prefs().classesLoading);
            showPageLoader(button.get(), 'button');
        });
        this.showProgressBar();

        if (this.has('setItems')) {
            this.items.map((widget) => {
                if (widget.config.widget === 'productDetail' && widget.readyToOrder) {
                    childPids.push({
                        pid: widget.currentProductID || widget.prefs().pid,
                        qty: widget.selectedQuantity || 1
                    });
                }
            });
            addToCartParams.pidsObj = JSON.stringify(childPids);
        } else if (this.has('bundleItems')) {
            this.items.map((widget) => {
                if (widget.config.widget === 'productDetail' && widget.readyToOrder) {
                    childPids.push({
                        pid: widget.currentProductID || widget.prefs().pid,
                        quantity: widget.selectedQuantity || 1
                    });
                }
            });
            addToCartParams.childProducts = JSON.stringify(childPids);
        }

        submitFormJson(addToCartUrl, addToCartParams)
            .then(response => this.postAddProduct(response))
            .finally(() => {
                this.addToCartButtons((button) => {
                    hidePageLoader(button.get(), 'button');
                    button.ref('self').removeClass(this.prefs().classesLoading);
                });
                this.hideProgressBar();
            }).catch(() => {
                this.networkError();
            });
    }
    checkAddToCart() {
        this.readyToOrder = true;
        this.items.map((widget) => {
            if (widget.config.widget === 'productDetail') {
                this.readyToOrder = this.readyToOrder && widget.readyToOrder;
            }
        });
        this.addToCartButtons((button) => button[this.readyToOrder ? 'enable' : 'disable']());
    }
    networkError() {
        this.showNotifyMsg(this.prefs().textNetworkError, true);
    }
    showNotifyMsg(message = '', isError = false) {
        this.has(this.prefs().elNotifyMsg, elNotifyMsg => {
            elNotifyMsg
                .data(isError ? 'setError' : 'setText', message)
                .show();

            this.onDestroy(timeout(() => {
                elNotifyMsg
                    .hide();
            }, this.prefs().msgTime));
        });
    }
    updateProduct(updateBtn) {
        this.addToCartButtons((button) => {
            button.ref('self').addClass(this.prefs().classesLoading);
            showPageLoader(button.get(), 'button');
        });
        submitFormJson(
            updateBtn.ref('self').attr('data-update-cart-url'),
            {
                pid: this.currentProductID || updateBtn.prefs().pid,
                quantity: this.selectedQuantity || updateBtn.ref('self').attr('data-selected-quantity') || 1,
                uuid: updateBtn.ref('self').attr('data-uuid')
            }
        ).then(this.afterUpdateProduct.bind(this))
            .finally(() => {
                this.addToCartButtons((button) => {
                    hidePageLoader(button.get(), 'button');
                    button.ref('self').removeClass(this.prefs().classesLoading);
                });
                this.emit('updated');
                this.eventBus().emit('emarsys.update');
            });

    }
    afterUpdateProduct(response) {
        this.eventBus().emit('product.updated', response.cartModel);
    }
    updateAddToCartButtonText(product) {
        const { availability = {} } = product;
        let buttonText = this.config.Resources.btn.addtocart;

        if (availability.isPreOrder) {
            buttonText = this.config.Resources.btn.preorder;
        } else if (availability.isBackOrder) {
            buttonText = this.config.Resources.btn.backorder;
        }

        this.addToCartButtons((button) => {
            if (!button.data('skip-update')) {
                button.setText(buttonText);
            }
        });
    }
    updateImages(product) {
        if (product.imagesData) {
            this.has('imageCarousel', imageCarousel => {
                imageCarousel.data('updateSlides', { images: product.imagesData });
            });
            if (product.imagesData.length > 0) {
                this.has('productPicture', productPicture => {
                    productPicture.data('setSource', product.imagesData[0], false, true);
                });

                if (this.isquickview) {
                    const productImageUrl = product.imagesData[0].url;
                    const pictureElement = this.ref('self').els[0].querySelector('.b-product-picture__picture');
                    const productImg = pictureElement && pictureElement.querySelector('img');
                    const productSource = pictureElement && pictureElement.querySelector('source');

                    if (productImg) {
                        productImg.setAttribute('src', productImageUrl);
                    }

                    if (productSource) {
                        productSource.setAttribute('srcset', productImageUrl);
                    }
                }
            }
        }
    }
    updateProductId(product) {
        this.getById('addToWishlist', addToWishlistButton => {
            addToWishlistButton.data('pid', product.id);
            addToWishlistButton.data('checkProductInlist');
        });
    }
    ubdateBadge(product) {
        if (product.badge) {
            this.getById('imageCarousel', imageCarousel => {
                imageCarousel.has('badge', badge => badge.setText(product.badge));
            });
        }
    }
    /**
     * @param {any} product productModel
     * @param {string} [availabilityMsg] default message
     */
    updateProductView(product, availabilityMsg) {
        var defaultAttributes = ['color', 'size', 'length'];
        this.currentProductID = product.id;
        this.analytics = product.analytics;
        this.selectedQuantity = product.selectedQuantity;
        this.uuid = product.uuid;
        if (product.variationAttributes && product.variationAttributes.length) {
            product.variationAttributes.forEach(variationAttribute => {
                var attrIndex = defaultAttributes.indexOf(variationAttribute.attributeId);
                if (attrIndex !== -1) {
                    defaultAttributes.splice(attrIndex, 1);
                }
                variationAttribute.values = variationAttribute.values.map(value => {
                    return {
                        ...value,
                        selected: value.selected ? 'selected' : '',
                        selectable: value.selectable ? 'selectable' : '',
                        disabled: value.selected && variationAttribute.attributeId === 'color' ? 'disabled' : ''
                    };
                });
                this.ref('attr-' + variationAttribute.attributeId).render('template', {
                    attr: variationAttribute
                });
                this.ref('attr-' + variationAttribute.attributeId).show();
            });

            defaultAttributes.forEach(attribute => {
                this.ref('attr-' + attribute).hide();
            });
        }
        if (product.quantities) {
            ['null', 1, 2, 3, 3].forEach(idx => { // dynamically created ID
                if (this.has('quantity-' + idx)) {
                    const ref = this.ref('quantity-' + idx);
                    ref.render('template', {
                        attr: {
                            value: idx,
                            values: product.quantities.map(qty => {
                                return {
                                    selected: qty.selected ? 'selected' : '',
                                    url: qty.url,
                                    value: qty.value
                                };
                            })
                        }
                    });
                }
            });
        }
        if (product.price && product.price.html && this.has('priceBlock')) {
            this.ref('priceBlock').render('template', [], void 0, product.price.html);
        }

        this.has('availabilityLabel', availabilityLabel => {
            var message = '';
            if (product.availability && product.availability.messages && product.readyToOrder) {
                message = product.availability.messages.join('');
            }
            availabilityLabel.setText(message || availabilityMsg || '');
        });

        this.has('productDetailsLink', productDetailsLink => {
            productDetailsLink.attr('href', product.selectedProductUrl);
        });

        this.readyToOrder = product.readyToOrder && product.available;
        this.addToCartButtons((button) => button[this.readyToOrder ? 'enable' : 'disable']());

        this.updateImages(product);
        this.updateProductId(product);
        this.ubdateBadge(product);
        this.updateAddToCartButtonText(product);
        this.updateTabs(product);
        this.updateOtherElements(product);

        var isUnavailable = product.available === false;
        var dependentOnAvailability = window.document.querySelectorAll('[data-class-on-unavailable]');
        dependentOnAvailability.forEach(x => {
            if (isUnavailable && product.notifyMe) {
                x.classList.add(x.dataset.classOnUnavailable);
            } else {
                x.classList.remove(x.dataset.classOnUnavailable)
            }
        });


        this.emit('updatedview');
    }

    updateTabs({ tabs } = []) {
        this.has('productTabs', productTabs => {
            productTabs.data('updateTabs', {
                tabs: tabs.map((tab, index) => Object({
                    ...tab,
                    isActive: !index,
                    index: index
                }))
            });
        });
    }

    /**
     *
     * @param {InstanceType<ReturnType<import('widgets/forms/InputSelect').default>>} selectWidget
     *   widget triggered event
     */
    changeAttribute(selectWidget) {
        const selected = selectWidget.getSelectedOptions();
        var dataUrl = selected.attr('data-attr-url');
        var queryJSON = selected.attr('data-query-json');

        if (queryJSON) {
            dataUrl = this.setProductVariationUrl(decodeURIComponent(queryJSON));
        }

        if (selected) {
            this.showProgressBar();
            submitFormJson(dataUrl, void 0, 'GET', true)
                .then(this.afterChangeAttribute.bind(this))
                .finally(() => {
                    this.hideProgressBar();
                }).catch(e => {
                    showErrorLayout(e);
                    this.networkError();
                });
        }


    }
    afterChangeAttribute(response) {
        if (response && response.product) {
            if (this.prefs().updateHistory && response.product.selectedVariationGroupUrl) {
                this.updateProductId(response.product);
                this.updatePageTitle(response.product);
                window.history.replaceState({stateCount: !window.history.state ? 1 : ++window.history.state.stateCount, reviewed: false}, '', response.product.selectedVariationGroupUrl);
                this.eventBus().emit('product.history.updated', response.product);
                window.redirected = false;
                window.addEventListener('popstate', event => {
                    event.preventDefault();
                    if (!window.redirected) {
                        window.redirected = true;
                        window.history.go(-1);
                    }
                });
            } else if (response.product.selectedVariationGroupUrl) {
                this.eventBus().emit('product.quickview.updated', response.product);
            }
            this.updateProductView(
                response.product
            );
        }
    }
    /**
     * @param {string} queryJSON json with query params
     * @returns {string} product variation url
     */
    setProductVariationUrl(queryJSON) {
        const query = JSON.parse(queryJSON);
        const url = new URL(window.location.origin + query.endpoint);

        for (var key in query.params) {
            if (query.params.hasOwnProperty(key)) {
                url.searchParams.set(key, query.params[key]);
            }
        }

        return url.href;
    }
    updatePageTitle(product) {
        let title = product.pageTitle || product.productName;

        if (product.variationAttributes) {
            for (var attr of product.variationAttributes) {
                if (attr.attributeId === 'color') {
                    title = title ? title + ' | ' + attr.displayValue : '';
                    break;
                }
            }
        }

        if (title) {
            title += ' | hush';
            document.title = title;
        }
    }
    updateProductName(product) {
        try {
            const name = product.productName;
            let productName;
            if (name) {
                if (!window.document.body.querySelector('.b-product-set-item__list')) {
                    productName = window.document.body.querySelector('.b-product__name');

                    if (productName) {
                        productName.innerText = name;
                    }

                    const breadcrumbs = window.document.body.querySelectorAll('.b-breadcrumb__item');

                    if (breadcrumbs.length > 0) {
                        breadcrumbs[breadcrumbs.length - 1].innerText = name;
                    }
                } else {
                    productName = this.ref('self').els[0].querySelector('.b-product__name');
                    if (productName) {
                        productName.innerText = name;
                    }
                }
            }
        } catch (error) {
            window.console.error('Error during name updating: ' + error);
        }
    }
    updateBazaarvoiceId(product) {
        var id = product.id;
        var bvVariationID = product.bvVariationID;
        var additionalMasterFamily = product.additionalMasterFamily;
        var bazaarvoiceContainer = $('.bv-container');

        if (id && bvVariationID) {
            bazaarvoiceContainer.attr('data-bv-productid', bvVariationID);
        }

        if (id && additionalMasterFamily) {
            bazaarvoiceContainer.attr('data-bv-family-product-id', additionalMasterFamily);
        }
    }
    scrollTo(widget, button) {
        const targetRef = button ? button.prefs().targetRef : widget.prefs().targetRef;
        const target = this.ref(targetRef);
        if (target) {
            windowScrollTo(target.offset().top);
        }
    }
    updateOtherElements(product) {
        this.has('productRecommendations', productRecommendations => {
            if (product.urls && product.urls.recommendations) {
                const recommendations = product.recommendations.join(',');
                if (productRecommendations.data('recommendations') !== recommendations) {
                    const productRecommendationsEl = productRecommendations.get();
                    showPageLoader(productRecommendationsEl, 'inside');
                    getContentByUrl(product.urls.recommendations).then(response => {
                        productRecommendations.empty();
                        productRecommendationsEl.innerHTML = response || '';
                        productRecommendations.data('recommendations', recommendations);
                    }).finally(() => {
                        hidePageLoader(productRecommendationsEl, 'inside');
                    });
                }
            }
        });
        this.updateProductName(product);
        this.updateBazaarvoiceId(product);
        this.updateDuelCarousel(product);
    }
    showProgressBar() {

    }
    hideProgressBar() {

    }
    handleReviewClick() {
        window.history.replaceState({ stateCount: !window.history.state ? 1 : ++window.history.state.stateCount, reviewed: false }, '', location.href);
        window.redirected = false;
        window.addEventListener('popstate', event => {
            event.preventDefault();
            if (!window.redirected) {
                window.redirected = true;
                if (window.history.state) {
                    window.history.go(-(window.history.state.stateCount));
                } else {
                    window.history.go(-1);
                }
            }
        });
        window.document.getElementById('reviews').scrollIntoView();
    }

    showReviewsModal() {
        const reviewsModalEl = document.querySelector('.bv-reviews-container-modal');
        reviewsModalEl?.classList.add('show');
    }

    closeReviewsModal() {
        const reviewsModalEl = document.querySelector('.bv-reviews-container-modal');
        reviewsModalEl?.classList.remove('show');
    }

    /**
     * @param {any} product productModel
     * @returns {void}
     */
    updateDuelCarousel(product) {
        this.has('carouselDuel', carouselDuel => {
            const parentEl = carouselDuel.get();
            
            if (parentEl) {
                const productDuelEl = parentEl.querySelector('div');
                const targetEl = parentEl.querySelector('.b-carousel__track');
                
                if (productDuelEl && targetEl) {
                    let dataUrl = productDuelEl.getAttribute('data-carousel-url');
                    
                    if (dataUrl) {
                        const newProductId = product.variationGroupSku || product.id;
                        dataUrl = dataUrl.replace(/productId=[^&]+/, `productId=${newProductId}`);
                        productDuelEl.setAttribute('data-carousel-url', dataUrl);
                        
                        getContentByUrl(dataUrl).then(response => {
                            targetEl.innerHTML = response || '';
                        }).finally(() => {
                            window.dispatchEvent(new Event('resize'));
                        });
                    }
                }
            }
        });
    }

}

